import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FileDialogButtonView from '@ckeditor/ckeditor5-upload/src/ui/filedialogbuttonview';
import AttachFileIcon from 'bootstrap-icons/icons/camera-video.svg';
import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget/src/utils'

export default class InsertImage extends Plugin {

    static get requires() {
        return ["Widget"];
    }

    init() {
        const editor = this.editor;
        console.log(editor.config.get("video"));
        const conversion = editor.conversion;
        const t = editor.t;

        editor.model.schema.register('video', { allowAttributes: ['class', 'data-toggle', 'title'] });

        editor.model.schema.register('infoBox', {
            allowWhere: '$block',
            allowContentOf: '$root',
            isObject: true,
            allowAttributes: ['src', "controls", "preload", "height", 'data-setup', "infoBoxType"] // Added.
        });

        conversion.for('dataDowncast')
            .elementToElement({
                model: 'infoBox',
                view: (modelElement, { writer }) => createVideoViewElement(writer, modelElement)
            });

        conversion.for('editingDowncast')
            .elementToElement({
                model: 'infoBox',
                view: (modelElement, { writer }) => toVideoWidget(
                    createVideoViewElement(writer, modelElement), writer, t('video widget')
                )
            });

        editor.ui.componentFactory.add('insertVideo', locale => {
            const view = new FileDialogButtonView(locale);
            view.set({
                label: 'Chèn Video',
                acceptedType: '*',
            });
            view.buttonView.set({
                label: 'Chèn Video',
                icon: AttachFileIcon,
                tooltip: true
            });

            view.on('done', (evt, files) => {
                for (const file of Array.from(files)) {
                    const fileRepo = editor.plugins.get('FileRepository');
                    const loader = fileRepo.createLoader(file);
                    loader.upload();
                    console.log(loader)
                    // const fileLoader = fileRepo.getLoader(yourNativeFileInstance);                   
                    loader.on('change:uploadResponse', (evt, name, value, oldValue) => {
                        if (value.default) {
                            editor.model.change(writer => {
                                let protocol = editor.config.get("video.defaultProtocol");
                                if (protocol == null) {
                                    protocol = ""
                                }
                                console.log("uploaded:", protocol + value.default); // your data                        

                                const footnoteElement = writer.createElement('infoBox', {
                                    "src": protocol + value.default
                                });
                                editor.model.insertContent(footnoteElement, editor.model.document.selection);
                            });
                        }
                    });
                }
            });

            return view;
        })
    }
}

function toVideoWidget(viewElement, writer, src) {
    // writer.setAttribute('src', src, viewElement);

    return toWidget(viewElement, writer);
}
function createVideoViewElement(writer, model) {
    // console.log(model)
    const src = model.getAttribute('src');
    const containerVideo = writer.createContainerElement('video', {
        class: 'video-js vjs-fluid',
        "preload": "auto",
        "height": 350,
        "data-setup": "{}",
        "style": "width:'100%'",
        controls: true
    });

    const container = writer.createContainerElement('figure')

    const source = writer.createEmptyElement('source', { src: src, type: "video/mp4" })
    const source2 = writer.createEmptyElement('source', { src: src, type: "video/ogg" })

    writer.insert(writer.createPositionAt(containerVideo, 0), source);
    writer.insert(writer.createPositionAt(containerVideo, 1), source2);
    writer.insert(writer.createPositionAt(container, 0), containerVideo);

    return container;
}